module.exports = __webpack_public_path__ + "static/media/chanel-coco-noir-big.e4814859.png";